import { render } from "./RewardSystemView.vue?vue&type=template&id=6fda31d0"
import script from "./RewardSystemView.vue?vue&type=script&lang=js"
export * from "./RewardSystemView.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1559117955/src/employer_portal_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__